export enum NewLoginView {
    activateAccount = 'activateAccount',
    alreadyActive = 'alreadyActive',
    alreadyConsumedToken = 'alreadyConsumedToken',
    chooseMfaMethod = 'chooseMfaMethod',
    createPassword = 'createPassword',
    downloadMfaApp = 'downloadMfaApp',
    expiredToken = 'expiredToken',
    scanMfaQrCode = 'scanMfaQrCode',
    setHardwareToken = 'setHardwareToken',
    successPage = 'successPage',
    termsOfUse = 'termsOfUse',
    tokenResent = 'tokenResent',
}
